// Body-Up Translations - FR/EN

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      pricing: "Tarifs",
      faq: "FAQ",
      contact: "Contact",
      parking: "Parking",
      book: "Réserver",
      bookSession: "Réserver une séance"
    },
    // Hero section
    hero: {
      badge: "Studio privé de Personal Training à Nyon",
      onlineCoachingBadge: "Nouveau : Coaching en ligne",
      title1: "Votre Transformation",
      title2: "Commence Ici",
      subtitle: "Coaching 100% personnalisé dans un espace privé de 150m². Atteignez vos objectifs avec un accompagnement premium et des équipements de pointe.",
      cta: "Consultation Gratuite",
      discoverServices: "Découvrir nos services",
      features: {
        private: "Séances 100% privées",
        experience: "Coach depuis 2005",
        price: "Dès 65 CHF/séance"
      }
    },
    // EMS Badge
    emsBadge: {
      text: "Nouveau : EMS Drysuit en Groupe",
      discover: "Decouvrir l'EMS en Groupe"
    },
    // Benefits section
    benefits: {
      subtitle: "Pourquoi Body-Up",
      title: "L'Excellence du Personal Training",
      description: "Un accompagnement sur mesure dans un cadre exclusif pour des résultats exceptionnels.",
      items: [
        {
          emoji: "🔒",
          title: "Studio 100% Privé",
          description: "150m² entièrement réservés pour vous. Aucune distraction, concentration totale sur vos objectifs."
        },
        {
          emoji: "🎯",
          title: "Programme Sur Mesure",
          description: "Chaque séance est adaptée à votre niveau, vos objectifs et votre évolution."
        },
        {
          emoji: "📊",
          title: "Analyse 3D Styku",
          description: "Technologie de pointe pour un suivi précis de votre composition corporelle."
        },
        {
          emoji: "🏆",
          title: "20+ Ans d'Expertise",
          description: "Des coachs diplômés et passionnés avec une expérience éprouvée."
        },
        {
          emoji: "⚡",
          title: "Équipements Premium",
          description: "EMS, Power Plate, Hypoxico... Les meilleures technologies à votre service."
        },
        {
          emoji: "❤️",
          title: "Suivi Complet",
          description: "Entraînement + nutrition + récupération. Une approche holistique de votre bien-être."
        }
      ]
    },
    // Services
    services: {
      subtitle: "Nos Prestations",
      title: "Des Services Sur Mesure",
      description: "Du personal training classique aux technologies les plus innovantes.",
      viewAll: "Voir tous nos services",
      learnMore: "En savoir +",
      items: {
        "personal-training": {
          title: "Personal Training",
          description: "Coaching fitness 100% individualisé pour atteindre vos objectifs spécifiques.",
          intro: "Le Personal Training chez Body-Up, c'est bien plus qu'un simple entraînement. C'est une expérience de coaching 100% privée et personnalisée dans notre studio de 150m² entièrement équipé.",
          benefits: [
            "Programme sur mesure adapté à VOS objectifs",
            "Coaching 1:1 dans un espace 100% privé",
            "Suivi précis de votre progression",
            "Techniques d'entraînement professionnelles",
            "Motivation et accompagnement constant"
          ],
          forWho: "Que vous souhaitiez perdre du poids, prendre de la masse musculaire, améliorer votre condition physique ou vous préparer pour un événement sportif, nos coachs experts créent un programme adapté à vos besoins et votre emploi du temps.",
          badge: "🏆 N°1 à Nyon"
        },
        "ems-training": {
          title: "EMS Drysuit",
          description: "Technologie XBody Drysuit sans fil. Une séance courte et très intense (20-25 min) qui stimule l'ensemble du corps. Installation en 30 secondes.",
          intro: "La technologie XBody Drysuit represente la 3e generation d'EMS : une combinaison seche, 100% sans fil, qui s'installe en 30 secondes. Les electrodes integrees aux epaules, bras, abdominaux, fessiers et cuisses stimulent un grand nombre de groupes musculaires en parallele.",
          benefits: [
            "20 min EMS = stimulation intense de tout le corps",
            "Installation ultra-rapide en 30 secondes",
            "Combinaison seche sans fil (Drysuit)",
            "Electrodes integrees aux epaules et tout le corps",
            "3e generation XBody - la plus avancee",
            "Sans impact sur les articulations"
          ],
          forWho: "Parfait pour les professionnels actifs, les personnes en rééducation ou ceux qui cherchent une alternative efficace aux entraînements traditionnels.",
          badge: "⚡ Technologie avancée"
        },
        "3d-scanner": {
          title: "Scanner 3D Styku",
          description: "Analyse précise de votre composition corporelle pour des stratégies fitness personnalisées.",
          intro: "Le Scanner 3D Styku est une technologie de pointe qui crée un modèle 3D complet de votre corps en quelques secondes, offrant des données précises sur votre composition corporelle.",
          benefits: [
            "Analyse de composition corporelle ultra-précise",
            "Suivi de vos mensurations en temps réel",
            "Visualisation 3D de votre corps",
            "Définition d'objectifs réalistes et mesurables",
            "Comparaison avant/après motivante"
          ],
          forWho: "Indispensable pour tous ceux qui veulent suivre leur transformation avec précision et ajuster leur programme en fonction de données concrètes.",
          badge: "🎯 Précision scientifique"
        },
        "boxing": {
          title: "Initiation Boxe",
          description: "Apprenez les fondamentaux de la boxe, améliorez votre condition physique et votre coordination.",
          intro: "Découvrez l'art noble de la boxe dans un cadre privé et bienveillant. Nos séances d'initiation vous permettent d'apprendre les techniques fondamentales tout en vous défoulant.",
          benefits: [
            "Cardio intense et brûlage de calories maximal",
            "Amélioration de la coordination et des réflexes",
            "Renforcement musculaire complet",
            "Évacuation du stress et confiance en soi",
            "Apprentissage dans un cadre sécurisé"
          ],
          forWho: "Ouvert à tous les niveaux, de la découverte à la préparation de combats amateurs. Aucune expérience préalable requise !",
          badge: "🥊 Défoulez-vous !"
        },
        "power-plate": {
          title: "Power Plate",
          description: "Entraînements complets accélérés utilisant la technologie de vibration pour des résultats rapides.",
          intro: "Le Power Plate utilise des vibrations triplanaires pour activer vos muscles de manière réflexe, rendant chaque exercice jusqu'à 3x plus efficace.",
          benefits: [
            "Activation musculaire jusqu'à 97% des fibres",
            "Amélioration de la circulation sanguine",
            "Renforcement musculaire en profondeur",
            "Réduction de la cellulite",
            "Gain de souplesse et d'équilibre"
          ],
          forWho: "Idéal en complément d'un programme de personal training ou pour ceux qui recherchent une récupération active et un travail musculaire profond.",
          badge: "🔄 Vibrations efficaces"
        },
        "hypoxico": {
          title: "Hypoxico",
          description: "Entraînement en simulation d'altitude pour améliorer vos performances cardiovasculaires.",
          intro: "L'Hypoxico simule les conditions d'altitude (jusqu'à 6400m) pour entraîner votre corps à optimiser l'utilisation de l'oxygène - la même technologie utilisée par les athlètes olympiques.",
          benefits: [
            "Amélioration de l'endurance et du VO2max",
            "Accélération du métabolisme",
            "Production accrue de globules rouges",
            "Préparation à l'altitude pour les sports de montagne",
            "Récupération active optimisée"
          ],
          forWho: "Parfait pour les sportifs d'endurance, les amateurs de sports de montagne ou ceux qui cherchent à booster leur métabolisme naturellement.",
          badge: "🏔️ Entraînement altitude"
        },
        "fitsonic": {
          title: "Fitsonic",
          description: "Traitement innovant combinant fitness et technologie pour la réduction de la cellulite.",
          intro: "Le Fitsonic combine ultrasons, infrarouge et drainage pour cibler efficacement la cellulite et raffermir votre silhouette.",
          benefits: [
            "Réduction visible de la cellulite",
            "Raffermissement de la peau",
            "Stimulation du drainage lymphatique",
            "Amélioration de la circulation",
            "Résultats visibles après quelques séances"
          ],
          forWho: "Idéal pour ceux qui souhaitent affiner leur silhouette et combattre la cellulite de manière non-invasive, en complément d'un programme sportif.",
          badge: "✨ Anti-cellulite"
        },
        "online-coaching": {
          title: "Coaching en ligne",
          description: "Accompagnement 100% personnalisé à distance via Zoom et suivi SMS pour atteindre vos objectifs où que vous soyez.",
          intro: "Le Coaching en ligne Body-Up vous permet de bénéficier de l'expertise de nos coachs où que vous soyez dans le monde. Des séances live via Zoom et un suivi quotidien par SMS pour un accompagnement structuré et personnalisé.",
          benefits: [
            "Séances live via Zoom avec votre coach",
            "Suivi quotidien personnalisé par SMS",
            "Programme sur mesure adapté à votre environnement",
            "Flexibilité totale : entraînez-vous quand vous voulez",
            "Accès à votre coach 7j/7"
          ],
          forWho: "Idéal pour les expatriés, les voyageurs fréquents, ou ceux qui préfèrent s'entraîner depuis chez eux avec un accompagnement professionnel de qualité.",
          badge: "💻 100% à distance"
        },
        "nutrition": {
          title: "Plan Alimentaire",
          description: "Conseils nutritionnels personnalisés pour compléter votre parcours fitness.",
          intro: "La nutrition est un levier majeur de vos résultats. Nos plans alimentaires personnalisés sont conçus pour compléter parfaitement votre programme d'entraînement.",
          benefits: [
            "Analyse de vos habitudes alimentaires actuelles",
            "Plan nutritionnel adapté à vos objectifs",
            "Recettes simples et délicieuses",
            "Suivi et ajustements réguliers",
            "Conseils pratiques pour le quotidien"
          ],
          forWho: "Essentiel pour quiconque veut maximiser ses résultats, que ce soit pour perdre du poids, prendre de la masse ou améliorer sa santé globale.",
          badge: "🥗 Levier majeur des résultats"
        }
      }
    },
    // EMS Section
    emsSection: {
      badge: "Nouveau : XBody Drysuit - 3e Generation",
      title1: "Decouvrez le Drysuit",
      title2: "par XBody",
      description: "Body-Up est equipe de la technologie XBody Drysuit, la 3e generation d'EMS : combinaison seche, 100% sans fil, installation en 30 secondes. Electrodes integrees aux epaules, bras, abdominaux, fessiers et cuisses.",
      features: [
        "Body-Up = Coaching prive 1:1 en studio",
        "EMS Drysuit = Seances en petits groupes (max 4)",
        "Installation 30s, 100% sans fil, plus hygienique"
      ],
      cta: "Decouvrir le Drysuit chez Body-Up",
      stats: {
        minutes: "Minutes / séance",
        people: "Personnes max",
        muscles: "Muscles activés",
        frequency: "Par semaine"
      }
    },
    // Testimonials
    testimonials: {
      title: "Ce que disent nos clients",
      googleReviews: "Avis Google"
    },
    // FAQ
    faq: {
      subtitle: "FAQ",
      title: "Questions Fréquentes",
      viewAll: "Voir toutes les questions",
      items: [
        {
          emoji: "🤔",
          question: "Qu'est-ce que le Personal Training exactement ?",
          answer: "Le Personal Training est un coaching sportif 100% individualisé. Contrairement aux cours collectifs ou à l'entraînement seul en salle, vous bénéficiez d'un coach dédié qui conçoit un programme sur mesure, corrige vos mouvements en temps réel et vous motive à chaque séance. Chez Body-Up, les séances sont 100% privées dans notre studio de 150m²."
        },
        {
          emoji: "💰",
          question: "Le Personal Training est-il vraiment plus efficace qu'une salle de sport classique ?",
          answer: "Oui, les études montrent que le Personal Training est 3 à 5 fois plus efficace qu'un entraînement non encadré. Pourquoi ? Un programme adapté à VOS objectifs, une technique parfaite pour éviter les blessures, une progression optimisée, et surtout une motivation constante. Vous atteignez vos objectifs plus rapidement et de manière durable."
        },
        {
          emoji: "⏱️",
          question: "Combien de séances par semaine sont recommandées ?",
          answer: "Pour des résultats optimaux, nous recommandons 2 à 3 séances par semaine. Cependant, même 1 séance hebdomadaire, si elle est régulière et bien structurée, peut apporter des résultats significatifs. Lors de votre consultation gratuite, nous établissons ensemble un planning réaliste adapté à votre emploi du temps."
        },
        {
          emoji: "🎯",
          question: "Quels objectifs puis-je atteindre avec un Personal Trainer ?",
          answer: "Pratiquement tous ! Perte de poids, prise de masse musculaire, tonification, amélioration de la posture, préparation sportive, réathlétisation après blessure, gain de souplesse, amélioration cardiovasculaire... Nos coachs ont l'expertise pour vous accompagner vers n'importe quel objectif fitness ou santé."
        },
        {
          emoji: "👤",
          question: "Dois-je être déjà sportif pour commencer ?",
          answer: "Absolument pas ! Le Personal Training s'adapte à TOUS les niveaux, du débutant complet au sportif confirmé. C'est même l'idéal pour débuter car vous apprenez les bons mouvements dès le départ, évitant ainsi les mauvaises habitudes et les risques de blessure."
        },
        {
          emoji: "📅",
          question: "Comment se déroule la première consultation ?",
          answer: "La première consultation est gratuite et sans engagement ! Elle comprend : un entretien pour comprendre vos objectifs et votre historique, une évaluation de votre condition physique actuelle, une présentation du studio et des équipements, et la définition d'un plan d'action personnalisé. Vous repartez avec une vision claire de votre parcours."
        },
        {
          emoji: "🔒",
          question: "Les séances sont-elles vraiment privées ?",
          answer: "Oui, 100% ! Lors de votre séance chez Body-Up, vous êtes seul(e) avec votre coach dans notre studio de 150m². Aucune autre personne n'est présente. Cela permet une concentration totale, un coaching de qualité et une confidentialité complète."
        },
        {
          emoji: "🍎",
          question: "Un suivi nutritionnel est-il inclus ?",
          answer: "Nous proposons des conseils nutritionnels de base dans le cadre de votre coaching. Pour un accompagnement nutritionnel complet et personnalisé, nous proposons des plans alimentaires dédiés. La nutrition est un levier majeur de votre progression, c'est donc un élément clé de votre transformation !"
        },
        {
          emoji: "📍",
          question: "Où se situe le studio et y a-t-il un parking ?",
          answer: "Body-Up est situé Route des Tattes d'Oie 95, 1260 Nyon. Plusieurs parkings gratuits sont disponibles à proximité immédiate : parking Denner, parking du stade, et places visiteurs devant l'entrée. Nous sommes facilement accessibles depuis Gland, Rolle, Coppet et toute La Côte."
        },
        {
          emoji: "💳",
          question: "Quels sont les modes de paiement acceptés ?",
          answer: "Nous acceptons les paiements par Twint, virement bancaire et espèces. Les forfaits peuvent être payés en une fois ou échelonnés selon les formules. N'hésitez pas à nous contacter pour discuter des options de paiement."
        }
      ]
    },
    // CTA
    cta: {
      title: "Prêt à Transformer Votre Vie ?",
      description: "Réservez votre première consultation gratuite et découvrez comment Body-Up peut vous aider à atteindre vos objectifs.",
      button: "Réserver Ma Consultation Gratuite",
      localNote: "Coach sportif à Nyon • Clients de Gland, Rolle, Coppet, Genève"
    },
    // SEO Microcopy - Local SEO enrichment
    seo: {
      heroSubtext: "Votre coach sportif privé à Nyon, Vaud • Clients de Gland, Rolle, Coppet et Genève",
      servicesSubtext: "Personal training, EMS, perte de poids et renforcement musculaire à Nyon",
      contactSubtext: "Studio accessible depuis La Côte : Gland, Rolle, Coppet, Prangins, Founex",
      footerLocal: "Coach sportif Nyon | Personal Trainer Vaud | Fitness privé La Côte"
    },
    // Footer
    footer: {
      description: "Studio privé de personal training haut de gamme à Nyon. Coaching 100% personnalisé, équipements professionnels et accompagnement premium pour atteindre vos objectifs.",
      navigation: "Navigation",
      contact: "Contact",
      onGoogle: "sur Google",
      copyright: "Body-Up Personal Training. Tous droits réservés.",
      privacy: "Politique de confidentialité",
      terms: "Conditions générales",
      followUs: "Suivez-nous",
      phone: "Téléphone",
      email: "Email",
      address: "Adresse",
      readyTransform: "Prêt à transformer votre corps ?",
      bookNow: "Réservez votre consultation gratuite maintenant",
      bookButton: "Réserver",
      seoLinks: {
        title: "Nos services à Nyon",
        coachSportif: "Coach Sportif Nyon",
        pertePoids: "Perte de Poids Nyon",
        emsNyon: "EMS Training Nyon"
      }
    },
    // Contact Page
    contactPage: {
      subtitle: "Contact",
      title: "Parlons de Vos Objectifs",
      formTitle: "Envoyez-nous un message",
      firstName: "Prénom",
      lastName: "Nom",
      emailLabel: "Email",
      phoneLabel: "Téléphone",
      subjectLabel: "Sujet",
      messageLabel: "Message",
      messagePlaceholder: "Décrivez vos objectifs...",
      submitButton: "Envoyer le message",
      submitting: "Envoi en cours...",
      successMessage: "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
      errorMessage: "Une erreur est survenue. Veuillez réessayer ou nous contacter par téléphone.",
      subjects: {
        select: "Sélectionnez un sujet",
        trial: "Consultation gratuite",
        info: "Demande d'informations",
        pricing: "Renseignements tarifs",
        partnership: "Partenariat",
        other: "Autre"
      },
      directBooking: "Réservez Directement",
      directBookingText: "La façon la plus rapide de démarrer ? Réservez votre consultation gratuite en ligne.",
      accessParking: "Accès & Parking",
      howToReach: "Comment Nous",
      reachHighlight: "Rejoindre",
      parkingOptions: "Options de Parking",
      goodToKnow: "Bon à savoir",
      accessibleFrom: "Accessible depuis Gland, Rolle, Coppet",
      nearStation: "À 5 min de la gare de Nyon",
      busNearby: "Bus à proximité"
    },
    // About page
    about: {
      subtitle: "À Propos",
      title: "Notre Histoire",
      description: "Depuis 2011, Body-Up accompagne les Nyonnais dans leur transformation physique et leur bien-être.",
      studioTitle: "Un Studio Unique à Nyon",
      studioText1: "Body-Up est né d'une passion profonde pour le sport et le désir d'offrir un service de coaching d'exception. Notre studio de 150m² a été conçu pour offrir une expérience d'entraînement 100% privée et personnalisée.",
      studioText2: "Equipe des technologies les plus avancees (Scanner 3D Styku, EMS XBody Drysuit, Power Plate, Hypoxico), notre espace vous permet d'optimiser chaque seance pour des resultats visibles et durables.",
      studioText3: "Notre philosophie est simple : chaque client est unique, chaque programme doit l'être aussi. Que votre objectif soit la perte de poids, la prise de masse, la réathlétisation ou simplement améliorer votre bien-être, nous créons un parcours sur mesure pour vous.",
      yearsExcellence: "Années d'Excellence",
      teamSubtitle: "L'Équipe",
      teamTitle: "Des Coachs Passionnés",
      laurent: {
        role: "Fondateur & Personal Trainer",
        description: "Personal trainer depuis 2005 et fondateur de Body-Up en 2011, Laurent cumule plus de 20 ans d'expertise dans le domaine. Sportif accompli (boxe, jiu-jitsu brésilien, fitness/bodybuilding), il conçoit des programmes sur mesure qui vous emmènent plus loin que vous ne l'imaginez.",
        tags: ["Coach depuis 2005", "Diplômé FITSPRO", "Certifié EMS"]
      },
      tarah: {
        role: "Personal Trainer & Coach EMS",
        description: "Après une reconversion professionnelle, Tarah est coach sportive depuis plus de 5 ans. Spécialisée en musculation, personal training et cours collectifs, elle apporte son énergie et sa passion pour vous accompagner vers vos objectifs avec bienveillance et détermination.",
        tags: ["Diplômée STAPS", "Certifiée EMS", "+5 ans d'expérience"]
      },
      quote: "\"Prenez soin de votre corps, c'est le seul endroit où vous êtes obligé de vivre.\"",
      quoteAuthor: "— Jim Rohn",
      meetCta: "Rencontrons-nous",
      meetDescription: "Venez découvrir notre studio et discutons de vos objectifs lors d'une première consultation gratuite.",
      meetButton: "Réserver une consultation gratuite"
    },
    // Services page
    servicesPage: {
      subtitle: "Nos Services",
      title: "Prestations Sur Mesure",
      description: "Des solutions personnalisées pour chaque objectif, avec les meilleures technologies.",
      whoIsItFor: "Pour qui ?",
      benefits: "Les Avantages",
      bookCta: "Réserver une séance",
      backToServices: "Retour aux services",
      notFound: "Service non trouvé"
    },
    // Contact page
    contactPage: {
      subtitle: "Contact",
      title: "Parlons de Vos Objectifs",
      description: "Prenez contact avec nous pour planifier votre première consultation gratuite ou pour toute question.",
      form: {
        name: "Prénom",
        lastName: "Nom",
        email: "Email",
        phone: "Téléphone",
        subject: "Sujet",
        selectSubject: "Sélectionnez un sujet",
        subjects: {
          trial: "Consultation gratuite",
          info: "Demande d'informations",
          pricing: "Renseignements tarifs",
          partnership: "Partenariat",
          other: "Autre"
        },
        message: "Message",
        send: "Envoyer le message",
        sending: "Envoi en cours...",
        success: "Message envoyé avec succès ! Nous vous répondrons dans les plus brefs délais.",
        error: "Une erreur est survenue. Veuillez réessayer."
      },
      info: {
        title: "Informations",
        phone: "Téléphone",
        email: "Email",
        address: "Adresse",
        hours: "Horaires",
        hoursValue: "Sur rendez-vous uniquement",
        hoursNote: "Du lundi au samedi"
      },
      locationTitle: "Notre Localisation"
    },
    // Pricing page
    pricingPage: {
      subtitle: "Tarifs",
      title: "Nos Forfaits",
      description: "Des formules adaptées à vos objectifs et votre budget.",
      perPerson: "par personne",
      popular: "Populaire",
      session: "Séance",
      sessions: "Séances",
      scan: "Scan",
      scans: "Scans",
      month: "mois",
      perMonth: "/mois",
      total: "Total",
      perSession: "/séance",
      bookNow: "Réserver",
      categories: {
        "personal-training": "Personal Training",
        "duo-training": "Duo Training",
        "ems-training": "EMS Training",
        "ems-duo-training": "EMS Duo Training",
        "scan-3d": "Scan 3D Styku",
        "plan-alimentaire": "Plan Alimentaire",
        "hypoxie-fitsonic": "Hypoxie / Fitsonic"
      }
    },
    // Parking page
    parkingPage: {
      subtitle: "Accès & Parking",
      title: "Nous Trouver",
      description: "Plusieurs options de stationnement gratuites à moins de 2 minutes à pied.",
      address: "Route des Tattes d'Oie 95, 1260 Nyon, Suisse",
      openInMaps: "Ouvrir dans Google Maps",
      parkingOptions: "Options de Parking",
      goodToKnow: "Bon à savoir",
      goodToKnowText: "Tous ces parkings sont à moins de 2 minutes à pied de Body-Up. Les places devant l'entrée principale sont réservées en priorité à nos clients.",
      parkings: [
        {
          name: "Parking Denner",
          location: "Chemin des Saules",
          type: "Gratuit",
          icon: "🅿️"
        },
        {
          name: "Parking -1 visiteurs",
          location: "Let's Go Fitness - Chemin des Saules",
          type: "Visiteurs",
          icon: "🅿️"
        },
        {
          name: "Parking du Stade",
          location: "Route des Tattes d'Oie",
          type: "Public",
          icon: "⚽"
        },
        {
          name: "Entrée Body-Up",
          location: "Route des Tattes d'Oie 95",
          type: "2 places privées + visiteurs",
          icon: "🏋️"
        },
        {
          name: "École Tattes d'Oie",
          location: "Chemin d'Eysins (derrière école)",
          type: "~6 places visiteurs",
          icon: "🏫"
        }
      ],
      accessInfo: {
        title: "Informations d'Accès",
        items: [
          "Facilement accessible depuis Gland, Rolle, Coppet et toute La Côte",
          "À 5 minutes de la gare de Nyon",
          "Transports publics : Bus ligne à proximité"
        ]
      }
    },
    // Common
    common: {
      new: "NEW",
      loading: "Chargement..."
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      pricing: "Pricing",
      faq: "FAQ",
      contact: "Contact",
      parking: "Parking",
      book: "Book",
      bookSession: "Book a session"
    },
    // Hero section
    hero: {
      badge: "Private Personal Training Studio in Nyon",
      onlineCoachingBadge: "New: Online Coaching",
      title1: "Your Transformation",
      title2: "Starts Here",
      subtitle: "100% personalized coaching in a private 150m² space. Achieve your goals with premium support and cutting-edge equipment.",
      cta: "Free Consultation",
      discoverServices: "Discover our services",
      features: {
        private: "100% private sessions",
        experience: "Coach since 2005",
        price: "From 65 CHF/session"
      }
    },
    // EMS Badge
    emsBadge: {
      text: "New: Group EMS Drysuit Training",
      discover: "Discover Group EMS"
    },
    // Benefits section
    benefits: {
      subtitle: "Why Body-Up",
      title: "Personal Training Excellence",
      description: "Tailored support in an exclusive setting for exceptional results.",
      items: [
        {
          emoji: "🔒",
          title: "100% Private Studio",
          description: "150m² entirely reserved for you. No distractions, total focus on your goals."
        },
        {
          emoji: "🎯",
          title: "Custom Program",
          description: "Each session is adapted to your level, goals and progress."
        },
        {
          emoji: "📊",
          title: "3D Styku Analysis",
          description: "Cutting-edge technology for precise body composition tracking."
        },
        {
          emoji: "🏆",
          title: "20+ Years of Expertise",
          description: "Certified and passionate coaches with proven experience."
        },
        {
          emoji: "⚡",
          title: "Premium Equipment",
          description: "EMS, Power Plate, Hypoxico... The best technologies at your service."
        },
        {
          emoji: "❤️",
          title: "Complete Support",
          description: "Training + nutrition + recovery. A holistic approach to your well-being."
        }
      ]
    },
    // Services
    services: {
      subtitle: "Our Services",
      title: "Tailored Services",
      description: "From classic personal training to the most innovative technologies.",
      viewAll: "View all services",
      learnMore: "Learn more",
      items: {
        "personal-training": {
          title: "Personal Training",
          description: "100% individualized fitness coaching to achieve your specific goals.",
          intro: "Personal Training at Body-Up is much more than just a workout. It's a 100% private and personalized coaching experience in our fully equipped 150m² studio.",
          benefits: [
            "Custom program adapted to YOUR goals",
            "1:1 coaching in a 100% private space",
            "Precise tracking of your progress",
            "Professional training techniques",
            "Constant motivation and support"
          ],
          forWho: "Whether you want to lose weight, build muscle, improve your fitness or prepare for a sporting event, our expert coaches create a program tailored to your needs and schedule.",
          badge: "🏆 #1 in Nyon"
        },
        "ems-training": {
          title: "EMS Drysuit",
          description: "XBody Drysuit wireless technology. A short, very intense session (20-25 min) that stimulates the whole body. 30-second setup.",
          intro: "XBody Drysuit represents the 3rd generation of EMS: a dry, 100% wireless suit that installs in 30 seconds. Integrated electrodes at shoulders, arms, abs, glutes and thighs stimulate 90% of your muscles.",
          benefits: [
            "20 min EMS = intense full-body stimulation",
            "Ultra-fast 30-second setup",
            "Dry wireless suit (Drysuit)",
            "Integrated electrodes at shoulders and full body",
            "3rd generation XBody - most advanced",
            "No joint impact"
          ],
          forWho: "Perfect for active professionals, people in rehabilitation or those looking for an ultra-effective alternative. Drysuit technology makes the experience more comfortable and hygienic than ever.",
          badge: "⚡ XBody Drysuit - 3rd Generation"
        },
        "3d-scanner": {
          title: "3D Styku Scanner",
          description: "Precise body composition analysis for personalized fitness strategies.",
          intro: "The Styku 3D Scanner is cutting-edge technology that creates a complete 3D model of your body in seconds, providing accurate data on your body composition.",
          benefits: [
            "Ultra-precise body composition analysis",
            "Real-time measurement tracking",
            "3D visualization of your body",
            "Set realistic and measurable goals",
            "Motivating before/after comparison"
          ],
          forWho: "Essential for anyone who wants to track their transformation with precision and adjust their program based on concrete data.",
          badge: "🎯 Scientific precision"
        },
        "boxing": {
          title: "Boxing Initiation",
          description: "Learn the fundamentals of boxing, improve your fitness and coordination.",
          intro: "Discover the noble art of boxing in a private and supportive environment. Our initiation sessions allow you to learn fundamental techniques while letting off steam.",
          benefits: [
            "Intense cardio and maximum calorie burn",
            "Improved coordination and reflexes",
            "Complete muscle strengthening",
            "Stress relief and self-confidence",
            "Learning in a safe environment"
          ],
          forWho: "Open to all levels, from discovery to amateur fight preparation. No prior experience required!",
          badge: "🥊 Let off steam!"
        },
        "power-plate": {
          title: "Power Plate",
          description: "Accelerated full workouts using vibration technology for fast results.",
          intro: "Power Plate uses triplanar vibrations to activate your muscles reflexively, making each exercise up to 3x more effective.",
          benefits: [
            "Muscle activation up to 97% of fibers",
            "Improved blood circulation",
            "Deep muscle strengthening",
            "Cellulite reduction",
            "Flexibility and balance gains"
          ],
          forWho: "Ideal as a complement to a personal training program or for those seeking active recovery and deep muscle work.",
          badge: "🔄 Effective vibrations"
        },
        "hypoxico": {
          title: "Hypoxico",
          description: "Altitude simulation training to improve your cardiovascular performance.",
          intro: "Hypoxico simulates altitude conditions (up to 6400m) to train your body to optimize oxygen use - the same technology used by Olympic athletes.",
          benefits: [
            "Improved endurance and VO2max",
            "Accelerated metabolism",
            "Increased red blood cell production",
            "Altitude preparation for mountain sports",
            "Optimized active recovery"
          ],
          forWho: "Perfect for endurance athletes, mountain sports enthusiasts or those looking to boost their metabolism naturally.",
          badge: "🏔️ Altitude training"
        },
        "fitsonic": {
          title: "Fitsonic",
          description: "Innovative treatment combining fitness and technology for cellulite reduction.",
          intro: "Fitsonic combines ultrasound, infrared and drainage to effectively target cellulite and firm your figure.",
          benefits: [
            "Visible cellulite reduction",
            "Skin firming",
            "Lymphatic drainage stimulation",
            "Improved circulation",
            "Visible results after a few sessions"
          ],
          forWho: "Ideal for those who want to refine their figure and fight cellulite non-invasively, as a complement to a sports program.",
          badge: "✨ Anti-cellulite"
        },
        "online-coaching": {
          title: "Online Coaching",
          description: "100% personalized remote coaching via Zoom and SMS follow-up to achieve your goals wherever you are.",
          intro: "Body-Up Online Coaching allows you to benefit from our coaches' expertise wherever you are in the world. Live sessions via Zoom and daily SMS follow-up for guaranteed transformation.",
          benefits: [
            "Live sessions via Zoom with your coach",
            "Daily personalized SMS follow-up",
            "Custom program adapted to your environment",
            "Total flexibility: train when you want",
            "Access to your coach 7 days a week"
          ],
          forWho: "Ideal for expats, frequent travelers, or those who prefer to train from home with quality professional support.",
          badge: "💻 100% remote"
        },
        "nutrition": {
          title: "Nutrition Plan",
          description: "Personalized nutritional advice to complement your fitness journey.",
          intro: "Nutrition is a major lever of your results. Our personalized nutrition plans are designed to perfectly complement your training program.",
          benefits: [
            "Analysis of your current eating habits",
            "Nutrition plan adapted to your goals",
            "Simple and delicious recipes",
            "Regular monitoring and adjustments",
            "Practical daily advice"
          ],
          forWho: "Essential for anyone who wants to maximize their results, whether for weight loss, muscle gain or improving overall health.",
          badge: "🥗 Major lever for results"
        }
      }
    },
    // EMS Section
    emsSection: {
      badge: "New: XBody Drysuit - 3rd Generation",
      title1: "Discover Drysuit",
      title2: "by XBody",
      description: "Body-Up features XBody Drysuit technology, the 3rd generation of EMS: dry suit, 100% wireless, 30-second setup. Integrated electrodes at shoulders, arms, abs, glutes and thighs.",
      features: [
        "Body-Up = Private 1:1 coaching in studio",
        "EMS Drysuit = Sessions in small groups (max 4)",
        "30s setup, 100% wireless, more hygienic"
      ],
      cta: "Discover Drysuit at Body-Up",
      stats: {
        minutes: "Minutes / session",
        people: "People max",
        muscles: "Muscles activated",
        frequency: "Per week"
      }
    },
    // Testimonials
    testimonials: {
      title: "What our clients say",
      googleReviews: "Google Reviews"
    },
    // FAQ
    faq: {
      subtitle: "FAQ",
      title: "Frequently Asked Questions",
      viewAll: "See all questions",
      items: [
        {
          emoji: "🤔",
          question: "What exactly is Personal Training?",
          answer: "Personal Training is 100% individualized sports coaching. Unlike group classes or training alone at the gym, you benefit from a dedicated coach who designs a custom program, corrects your movements in real-time and motivates you at every session. At Body-Up, sessions are 100% private in our 150m² studio."
        },
        {
          emoji: "💰",
          question: "Is Personal Training really more effective than a regular gym?",
          answer: "Yes, studies show that Personal Training is 3 to 5 times more effective than unsupervised training. Why? A program adapted to YOUR goals, perfect technique to avoid injuries, optimized progression, and above all constant motivation. You achieve your goals faster and sustainably."
        },
        {
          emoji: "⏱️",
          question: "How many sessions per week are recommended?",
          answer: "For optimal results, we recommend 2 to 3 sessions per week. However, even 1 weekly session, if regular and well-structured, can bring significant results. During your free consultation, we establish a realistic schedule adapted to your availability."
        },
        {
          emoji: "🎯",
          question: "What goals can I achieve with a Personal Trainer?",
          answer: "Almost anything! Weight loss, muscle gain, toning, posture improvement, sports preparation, post-injury rehabilitation, flexibility gains, cardiovascular improvement... Our coaches have the expertise to guide you towards any fitness or health goal."
        },
        {
          emoji: "👤",
          question: "Do I need to be already athletic to start?",
          answer: "Absolutely not! Personal Training adapts to ALL levels, from complete beginner to confirmed athlete. It's even ideal for beginners because you learn the right movements from the start, avoiding bad habits and injury risks."
        },
        {
          emoji: "📅",
          question: "How does the first consultation go?",
          answer: "The first consultation is free and without commitment! It includes: an interview to understand your goals and history, an assessment of your current physical condition, a presentation of the studio and equipment, and the definition of a personalized action plan. You leave with a clear vision of your journey."
        },
        {
          emoji: "🔒",
          question: "Are the sessions really private?",
          answer: "Yes, 100%! During your session at Body-Up, you are alone with your coach in our 150m² studio. No other person is present. This allows total concentration, quality coaching and complete confidentiality."
        },
        {
          emoji: "🍎",
          question: "Is nutritional follow-up included?",
          answer: "We offer basic nutritional advice as part of your coaching. For complete and personalized nutritional support, we offer dedicated nutrition plans. Nutrition is a major lever of your progress, so it's a key element of your transformation!"
        },
        {
          emoji: "📍",
          question: "Where is the studio located and is there parking?",
          answer: "Body-Up is located at Route des Tattes d'Oie 95, 1260 Nyon. Several free parking lots are available nearby: Denner parking, stadium parking, and visitor spaces at the entrance. We are easily accessible from Gland, Rolle, Coppet and all of La Côte."
        },
        {
          emoji: "💳",
          question: "What payment methods are accepted?",
          answer: "We accept payments by credit card, Twint, bank transfer and cash. Packages can be paid at once or in installments depending on the formula. Don't hesitate to contact us to discuss payment options."
        }
      ]
    },
    // CTA
    cta: {
      title: "Ready to Transform Your Life?",
      description: "Book your first free consultation and discover how Body-Up can help you achieve your goals.",
      button: "Book My Free Consultation",
      localNote: "Personal trainer in Nyon • Clients from Gland, Rolle, Coppet, Geneva"
    },
    // SEO Microcopy - Local SEO enrichment
    seo: {
      heroSubtext: "Your private personal trainer in Nyon, Vaud • Clients from Gland, Rolle, Coppet and Geneva",
      servicesSubtext: "Personal training, EMS, weight loss and strength training in Nyon",
      contactSubtext: "Studio accessible from La Côte: Gland, Rolle, Coppet, Prangins, Founex",
      footerLocal: "Personal Trainer Nyon | Fitness Coach Vaud | Private Gym La Côte"
    },
    // Footer
    footer: {
      description: "Premium private personal training studio in Nyon. 100% personalized coaching, professional equipment and premium support to achieve your goals.",
      navigation: "Navigation",
      contact: "Contact",
      onGoogle: "on Google",
      copyright: "Body-Up Personal Training. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      followUs: "Follow us",
      phone: "Phone",
      email: "Email",
      address: "Address",
      readyTransform: "Ready to transform your body?",
      bookNow: "Book your free consultation now",
      bookButton: "Book",
      seoLinks: {
        title: "Our services in Nyon",
        coachSportif: "Personal Trainer Nyon",
        pertePoids: "Weight Loss Nyon",
        emsNyon: "EMS Training Nyon"
      }
    },
    // About page
    about: {
      subtitle: "About",
      title: "Our Story",
      description: "Since 2011, Body-Up has been supporting Nyon residents in their physical transformation and well-being.",
      studioTitle: "A Unique Studio in Nyon",
      studioText1: "Body-Up was born from a deep passion for sport and the desire to offer an exceptional coaching service. Our 150m² studio was designed to offer a 100% private and personalized training experience.",
      studioText2: "Equipped with the most advanced technologies (3D Styku Scanner, EMS XBody Drysuit, Power Plate, Hypoxico), our space allows you to optimize each session for visible and lasting results.",
      studioText3: "Our philosophy is simple: each client is unique, each program must be too. Whether your goal is weight loss, muscle gain, rehabilitation or simply improving your well-being, we create a custom journey for you.",
      yearsExcellence: "Years of Excellence",
      teamSubtitle: "The Team",
      teamTitle: "Passionate Coaches",
      laurent: {
        role: "Founder & Personal Trainer",
        description: "Personal trainer since 2005 and founder of Body-Up in 2011, Laurent has over 20 years of expertise in the field. An accomplished athlete (boxing, Brazilian jiu-jitsu, fitness/bodybuilding), he designs custom programs that take you further than you imagine.",
        tags: ["Coach since 2005", "FITSPRO Certified", "EMS Certified"]
      },
      tarah: {
        role: "Personal Trainer & EMS Coach",
        description: "After a career change, Tarah has been a sports coach for over 5 years. Specialized in weight training, personal training and group classes, she brings her energy and passion to guide you towards your goals with kindness and determination.",
        tags: ["STAPS Graduate", "EMS Certified", "+5 years experience"]
      },
      quote: "\"Take care of your body, it's the only place you have to live.\"",
      quoteAuthor: "— Jim Rohn",
      meetCta: "Let's Meet",
      meetDescription: "Come discover our studio and discuss your goals during a free first consultation.",
      meetButton: "Book a free consultation"
    },
    // Services page
    servicesPage: {
      subtitle: "Our Services",
      title: "Tailored Services",
      description: "Personalized solutions for every goal, with the best technologies.",
      whoIsItFor: "Who is it for?",
      benefits: "Benefits",
      bookCta: "Book a session",
      backToServices: "Back to services",
      notFound: "Service not found"
    },
    // Contact page
    contactPage: {
      subtitle: "Contact",
      title: "Let's Talk About Your Goals",
      description: "Contact us to schedule your first free consultation or for any questions.",
      formTitle: "Send us a message",
      firstName: "First Name",
      lastName: "Last Name",
      emailLabel: "Email",
      phoneLabel: "Phone",
      subjectLabel: "Subject",
      messageLabel: "Message",
      messagePlaceholder: "Describe your goals...",
      submitButton: "Send message",
      submitting: "Sending...",
      successMessage: "Message sent successfully! We will get back to you as soon as possible.",
      errorMessage: "An error occurred. Please try again or contact us by phone.",
      subjects: {
        select: "Select a subject",
        trial: "Free consultation",
        info: "Information request",
        pricing: "Pricing inquiry",
        partnership: "Partnership",
        other: "Other"
      },
      directBooking: "Book Directly",
      directBookingText: "The fastest way to get started? Book your free consultation online.",
      accessParking: "Access & Parking",
      howToReach: "How to",
      reachHighlight: "Reach Us",
      parkingOptions: "Parking Options",
      goodToKnow: "Good to Know",
      accessibleFrom: "Accessible from Gland, Rolle, Coppet",
      nearStation: "5 min from Nyon station",
      busNearby: "Bus nearby",
      form: {
        name: "First Name",
        lastName: "Last Name",
        email: "Email",
        phone: "Phone",
        subject: "Subject",
        selectSubject: "Select a subject",
        subjects: {
          trial: "Free consultation",
          info: "Information request",
          pricing: "Pricing inquiry",
          partnership: "Partnership",
          other: "Other"
        },
        message: "Message",
        send: "Send message",
        sending: "Sending...",
        success: "Message sent successfully! We will get back to you as soon as possible.",
        error: "An error occurred. Please try again."
      },
      info: {
        title: "Information",
        phone: "Phone",
        email: "Email",
        address: "Address",
        hours: "Hours",
        hoursValue: "By appointment only",
        hoursNote: "Monday to Saturday"
      },
      locationTitle: "Our Location"
    },
    // Pricing page
    pricingPage: {
      subtitle: "Pricing",
      title: "Our Packages",
      description: "Plans adapted to your goals and budget.",
      perPerson: "per person",
      popular: "Popular",
      session: "Session",
      sessions: "Sessions",
      scan: "Scan",
      scans: "Scans",
      month: "months",
      perMonth: "/month",
      total: "Total",
      perSession: "/session",
      bookNow: "Book Now",
      categories: {
        "personal-training": "Personal Training",
        "duo-training": "Duo Training",
        "ems-training": "EMS Training",
        "ems-duo-training": "EMS Duo Training",
        "scan-3d": "3D Styku Scan",
        "plan-alimentaire": "Nutrition Plan",
        "hypoxie-fitsonic": "Hypoxico / Fitsonic"
      }
    },
    // Parking page
    parkingPage: {
      subtitle: "Access & Parking",
      title: "Find Us",
      description: "Several free parking options within 2 minutes walk.",
      address: "Route des Tattes d'Oie 95, 1260 Nyon, Switzerland",
      openInMaps: "Open in Google Maps",
      parkingOptions: "Parking Options",
      goodToKnow: "Good to know",
      goodToKnowText: "All these parking lots are within 2 minutes walk of Body-Up. Spaces in front of the main entrance are reserved primarily for our clients.",
      parkings: [
        {
          name: "Denner Parking",
          location: "Chemin des Saules",
          type: "Free",
          icon: "🅿️"
        },
        {
          name: "Visitor Parking -1",
          location: "Let's Go Fitness - Chemin des Saules",
          type: "Visitors",
          icon: "🅿️"
        },
        {
          name: "Stadium Parking",
          location: "Route des Tattes d'Oie",
          type: "Public",
          icon: "⚽"
        },
        {
          name: "Body-Up Entrance",
          location: "Route des Tattes d'Oie 95",
          type: "2 private + visitor spaces",
          icon: "🏋️"
        },
        {
          name: "Tattes d'Oie School",
          location: "Chemin d'Eysins (behind school)",
          type: "~6 visitor spaces",
          icon: "🏫"
        }
      ],
      accessInfo: {
        title: "Access Information",
        items: [
          "Easily accessible from Gland, Rolle, Coppet and all of La Côte",
          "5 minutes from Nyon train station",
          "Public transport: Bus line nearby"
        ]
      }
    },
    // Common
    common: {
      new: "NEW",
      loading: "Loading..."
    }
  }
};
